export const toSumNumbersInArray = numbers => {
  return numbers.reduce((item, acumulator) => {
    return item + acumulator
  }, 0)
}

export default toSumNumbersInArray
